var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.69524 12.7532C6.05048 12.7532 5.52667 12.2294 5.52667 11.5846C5.52667 10.9418 6.05048 10.418 6.69524 10.418C7.34001 10.418 7.86382 10.9418 7.86382 11.5846C7.86382 12.2294 7.34001 12.7532 6.69524 12.7532ZM11.2381 12.7532C10.5933 12.7532 10.0695 12.2294 10.0695 11.5846C10.0695 10.9418 10.5933 10.418 11.2381 10.418C11.8829 10.418 12.4067 10.9418 12.4067 11.5846C12.4067 12.2294 11.8829 12.7532 11.2381 12.7532ZM14.6125 11.5846C14.6125 12.2294 15.1363 12.7532 15.7811 12.7532C16.4258 12.7532 16.9496 12.2294 16.9496 11.5846C16.9496 10.9418 16.4258 10.418 15.7811 10.418C15.1363 10.418 14.6125 10.9418 14.6125 11.5846Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.02 1.3623C5.21 1.3623 1 6.10842 1 11.3773C1 13.0599 1.49 14.7914 2.35 16.3738C2.51 16.6352 2.53 16.9647 2.42 17.2762L1.75 19.5195C1.6 20.0604 2.06 20.46 2.57 20.2997L4.59 19.6998C5.14 19.5195 5.57 19.7489 6.08 20.0604C7.54 20.9206 9.36 21.3623 11 21.3623C15.96 21.3623 21 17.5266 21 11.3473C21 6.01829 16.7 1.3623 11.02 1.3623Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chat-white.bdf22ca06f22af81cea251ea0d8f3eb4.svg";
export { ForwardRef as ReactComponent };